module.exports = __webpack_public_path__ + "static/media/email.e1ecffe4.svg";